module.exports = __webpack_public_path__ + "img/car-3.2317ff6c.png";